// Chat widget show/hide helpers.
//
// Teams Live Chat: enabled only on the main app subdomain (app.indexed.io).
// All other subdomains (staging, whitelabel partners, etc.) show an
// unavailability notice instead. The widget has no SDK — we manage visibility
// via DOM/CSS based on a three-phase lifecycle:
//   Phase 1 — page load:   button (.chatclient-button) is in the PARENT document
//   Phase 2 — chat open:   iframe expands to full chat window
//   Phase 3 — chat closed: button is now INSIDE the cross-origin iframe

(function() {
  var subdomain = window.location.hostname.split('.')[0];
  var teamsEnabled = subdomain === 'app';

  var BUTTON_MAX_PX    = 120; // iframe style width/height ~86px in button state
  var CHAT_FULL_MIN_PX = 300; // minimum px for a genuinely open chat window

  var parentBtn             = null;  // phase 1
  var frame                 = null;  // phases 2+3
  var iframeBroken          = false; // sticky — once broken, skip straight to error
  var ignoringFrameMutation = false;
  var errorDetectionTimeout = null;
  var creationCheckTimeout  = null;

  function ngNotify(method, title, description) {
    var injector = window.angular && window.angular.element(document.getElementById('ng-app')).injector();
    if (!injector) return;
    // $evalAsync is safe from both inside and outside the digest cycle — unlike
    // $apply it won't throw "digest already in progress" when called from ng-click.
    injector.get('$rootScope').$evalAsync(function() {
      injector.get('NotificationService')[method]({ title: title, description: description });
    });
  }

  function hideFrame() {
    if (!frame) return;
    if (errorDetectionTimeout !== null) { clearTimeout(errorDetectionTimeout); errorDetectionTimeout = null; }
    if (creationCheckTimeout  !== null) { clearTimeout(creationCheckTimeout);  creationCheckTimeout  = null; }
    ignoringFrameMutation = true;
    frame.style.display = 'none';
  }

  function showError() {
    iframeBroken = true;
    if (errorDetectionTimeout !== null) { clearTimeout(errorDetectionTimeout); errorDetectionTimeout = null; }
    if (frame) frame.style.display = 'none';
    ngNotify('addError', 'Chat Unavailable',
      'The chat widget failed to load. Please reload the page and try again, or ' +
      '<a href="mailto:support@indexed.io">contact support</a> if the issue persists.');
  }

  function startErrorDetectionTimer() {
    if (errorDetectionTimeout !== null) clearTimeout(errorDetectionTimeout);
    errorDetectionTimeout = setTimeout(function() {
      if (iframeBroken || !frame) return;
      var w = parseInt(frame.style.width)  || 0;
      var h = parseInt(frame.style.height) || 0;
      var isButtonState = w > 0 && w <= BUTTON_MAX_PX && h > 0 && h <= BUTTON_MAX_PX;
      var isFullyOpen   = w >= CHAT_FULL_MIN_PX && h >= CHAT_FULL_MIN_PX;
      if (!isButtonState && !isFullyOpen) showError();
    }, 5000);
  }

  if (teamsEnabled) {
    if (!document.getElementById('chatbot')) {
      var script = document.createElement('script');
      script.id = 'chatbot';
      script.type = 'text/javascript';
      script.src = 'https://res.public.onecdn.static.microsoft/customerconnect/v1/7dttl/init.js';
      script.setAttribute('environmentId', '895a2d1d-0674-e15d-8afc-b85dbe073112');
      script.setAttribute('region', 'unitedstates');
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);
    }

    window.showChat = function() {
      if (parentBtn) {
        // Phase 1: button is in parent DOM — click directly
        parentBtn.click();
      } else if (frame) {
        if (iframeBroken) { showError(); return; }
        // Phase 3: button is inside cross-origin iframe — un-hide so user can click it
        ignoringFrameMutation = true;
        frame.style.removeProperty('display');
      }
    };

    window.hideChat = function() {
      if (parentBtn) {
        parentBtn.style.setProperty('visibility', 'hidden', 'important');
        parentBtn.style.setProperty('pointer-events', 'none', 'important');
      }
      hideFrame();
    };
  } else {
    window.showChat = function() {
      ngNotify('addInfo', 'Chat Unavailable',
        'Live chat is not available. Please contact ' +
        '<a href="mailto:support@indexed.io">support@indexed.io</a> for assistance.');
    };
  }

  // Always watch for the Teams button — hide it permanently when teamsEnabled is off,
  // or manage it via showChat/hideChat lifecycle when on.
  new MutationObserver(function(mutations, btnObs) {
    var btn = document.querySelector('.chatclient-button');
    if (!btn) return;
    btnObs.disconnect();
    btn.style.setProperty('visibility', 'hidden', 'important');
    btn.style.setProperty('pointer-events', 'none', 'important');

    if (!teamsEnabled) return;

    parentBtn = btn;

    // Step 2: watch for the iframe to appear (first time user opens chat)
    new MutationObserver(function(mutations, frameObs) {
      var f = document.querySelector('iframe[id^="teams-chat-bot-iframe"]');
      if (!f) return;
      frameObs.disconnect();
      frame = f;
      parentBtn = null; // button is now inside the iframe

      // Step 3: watch iframe style — widget changes width/height to signal state
      new MutationObserver(function() {
        if (ignoringFrameMutation) {
          ignoringFrameMutation = false;
          return;
        }
        var w = parseInt(frame.style.width)  || 0;
        var h = parseInt(frame.style.height) || 0;
        var isButtonState = w > 0 && w <= BUTTON_MAX_PX && h > 0 && h <= BUTTON_MAX_PX;
        var isFullyOpen   = w >= CHAT_FULL_MIN_PX && h >= CHAT_FULL_MIN_PX;

        if (isButtonState) {
          hideFrame();
        } else if (isFullyOpen) {
          // Successfully expanded — cancel any pending error timers
          if (creationCheckTimeout  !== null) { clearTimeout(creationCheckTimeout);  creationCheckTimeout  = null; }
          if (errorDetectionTimeout !== null) { clearTimeout(errorDetectionTimeout); errorDetectionTimeout = null; }
        } else if (w > 0 && h > 0) {
          // Intermediate size — start/restart the expansion-failure timer
          startErrorDetectionTimer();
        }
      }).observe(frame, { attributes: true, attributeFilter: ['style'] });

      // Safety net: 5s after iframe creation. Handles complete load failure where
      // Teams never emits any style transitions (e.g. script crash, 0×0 iframe).
      creationCheckTimeout = setTimeout(function() {
        if (iframeBroken || !frame) return;
        var w = parseInt(frame.style.width)  || 0;
        var h = parseInt(frame.style.height) || 0;
        var isButtonState = w > 0 && w <= BUTTON_MAX_PX && h > 0 && h <= BUTTON_MAX_PX;
        var isFullyOpen   = w >= CHAT_FULL_MIN_PX && h >= CHAT_FULL_MIN_PX;
        if (!isButtonState && !isFullyOpen) showError();
      }, 5000);

    }).observe(document.body, { childList: true, subtree: true });

  }).observe(document.body, { childList: true, subtree: true });
})();
